var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" Образование ")]
      ),
      _c(
        "div",
        [
          _vm._l(_vm.localValue, function (education, i) {
            return [
              _c("c-item", {
                key: education.unique,
                staticClass: "item",
                attrs: {
                  value: education,
                  preview: _vm.preview,
                  editable: _vm.editable,
                  error: _vm.error && _vm.error.items && _vm.error.items[i],
                  "can-remove": true,
                },
                on: {
                  remove: function ($event) {
                    return _vm.removeEducation(education)
                  },
                },
              }),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "add-education" },
        [
          _c("c-button", {
            attrs: {
              icon: { icon: "plus", color: "primary" },
              label: "Добавить образование",
              disabled: _vm.preview || !_vm.editable || _vm.hasEmpty,
              size: "small",
            },
            on: { click: _vm.addEducation },
          }),
        ],
        1
      ),
      _vm.error && _vm.error.common
        ? _c("error-feedback", {
            attrs: { text: _vm.error && _vm.error.common },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }